import { Action, createAction, handleActions } from "redux-actions";
import { calculateDate } from "~libs/dateCalculator";
import { MERCADO_ABIERTO } from "~constants/negocios";
import { ABANDONADA } from "~constants/multicotizacionEstados";
import { EstadoValue, NegocioValue, RowsValue } from "../../types";

interface FiltrosCotizacionesState {
  page: number;
  take: RowsValue;
  fechaDesde: Date | string | null;
  fechaHasta: Date | string | null;
  searchCriteria: string;
  negocio: NegocioValue;
  estado: EstadoValue;
}

const setInitialStateCotizaciones = createAction(
  "SET_INITIAL_STATE_FILTRO_COTIZACIONES"
);

const setPage = createAction(
  "SET_LISTADO_COTIZACIONES_PAGE",
  (page: number) => ({
    page,
  })
);

const setTake = createAction(
  "SET_LISTADO_COTIZACIONES_ROWS_PER_PAGE",
  (take: RowsValue) => ({ take })
);

const selectFechaDesde = createAction(
  "SELECT_FECHA_DESDE_FILTRO",
  (fechaDesde: Date | string | null) => ({ fechaDesde })
);

const selectFechaHasta = createAction(
  "SELECT_FECHA_HASTA_FILTRO",
  (fechaHasta: Date | string | null) => ({ fechaHasta })
);

const selectSearchCriteria = createAction(
  "SELECT_ID_FILTRO",
  (searchCriteria: string) => ({
    searchCriteria,
  })
);

const selectNegocio = createAction(
  "SELECT_NEGOCIO_FILTRO",
  (negocio: NegocioValue) => ({
    negocio,
  })
);

const selectEstado = createAction(
  "SELECT_ESTADO_FILTRO",
  (estado: EstadoValue) => ({
    estado,
  })
);

const filtrosCotizacionesInitialState: FiltrosCotizacionesState = {
  page: 0,
  take: 10,
  fechaDesde: calculateDate(new Date(), -7),
  fechaHasta: new Date(),
  searchCriteria: "",
  negocio: MERCADO_ABIERTO,
  estado: ABANDONADA,
};

const filtrosCotizacionesReducer = handleActions<FiltrosCotizacionesState, any>(
  {
    [setInitialStateCotizaciones.toString()]: (): FiltrosCotizacionesState => {
      return {
        ...filtrosCotizacionesInitialState,
      };
    },
    [setPage.toString()]: (
      state: FiltrosCotizacionesState,
      action: Action<{ page: number }>
    ): FiltrosCotizacionesState => {
      return {
        ...state,
        page: action.payload.page,
      };
    },
    [setTake.toString()]: (
      state: FiltrosCotizacionesState,
      action: Action<{ take: RowsValue }>
    ): FiltrosCotizacionesState => {
      return {
        ...state,
        take: action.payload.take,
        page: 0,
      };
    },
    [selectFechaDesde.toString()]: (
      state: FiltrosCotizacionesState,
      action: Action<{ fechaDesde: Date | string | null }>
    ): FiltrosCotizacionesState => {
      return {
        ...state,
        fechaDesde: action.payload.fechaDesde,
      };
    },
    [selectFechaHasta.toString()]: (
      state: FiltrosCotizacionesState,
      action: Action<{ fechaHasta: Date | string | null }>
    ): FiltrosCotizacionesState => {
      return {
        ...state,
        fechaHasta: action.payload.fechaHasta,
      };
    },
    [selectSearchCriteria.toString()]: (
      state: FiltrosCotizacionesState,
      action: Action<{ searchCriteria: string }>
    ): FiltrosCotizacionesState => {
      return {
        ...state,
        searchCriteria: action.payload.searchCriteria,
      };
    },
    [selectNegocio.toString()]: (
      state: FiltrosCotizacionesState,
      action: Action<{ negocio: NegocioValue }>
    ): FiltrosCotizacionesState => {
      return {
        ...state,
        negocio: action.payload.negocio,
      };
    },
    [selectEstado.toString()]: (
      state: FiltrosCotizacionesState,
      action: Action<{ estado: EstadoValue }>
    ): FiltrosCotizacionesState => {
      return {
        ...state,
        estado: action.payload.estado,
      };
    },
  },
  filtrosCotizacionesInitialState
);

export { filtrosCotizacionesReducer };
export {
  setInitialStateCotizaciones,
  selectFechaDesde,
  selectFechaHasta,
  selectSearchCriteria,
  selectNegocio,
  selectEstado,
  setPage,
  setTake,
};
